"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurgicalDrugsAndGases_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SurgicalDrugsAndGases_Factory = /** @class */ (function () {
    function SurgicalDrugsAndGases_Factory() {
    }
    SurgicalDrugsAndGases_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            FavoriteStatus: model.FavoriteStatus,
            Name: model.Name,
            RecordId: model.RecordId,
            RecordStatus: model.RecordStatus,
            Type: model.Type,
        };
        return result;
    };
    SurgicalDrugsAndGases_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            FavoriteStatus: model.FavoriteStatus,
            Name: model.Name,
            RecordId: model.RecordId,
            RecordStatus: model.RecordStatus,
            Type: model.Type,
        };
        return result;
    };
    return SurgicalDrugsAndGases_Factory;
}());
exports.SurgicalDrugsAndGases_Factory = SurgicalDrugsAndGases_Factory;
